import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import {DashboardIcon} from "assets/icons";
import UseContext from "hooks/useContext";

const DashboardDL = () => {
    const {language} = UseContext()
    return (
        <SidebarUnitDesktop 
            routeName={"Tableau de Bord"} 
            routeSidebar={"/dashboard"}
            icon={DashboardIcon}
            text={language.getValue('sidebar.dashboard','Tableau de bord')}
            exactMatch={true}
        />
    );
};

export default DashboardDL;